"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiFormHelperText = getMuiFormHelperText;
function getMuiFormHelperText() {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    },
    styleOverrides: {
      root: {
        '&.Mui-error': {
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '16.41px',
          marginTop: 0
        }
      }
    }
  };
}